import React from 'react';
import { useParams } from "react-router-dom";

import CharacterSheetParent from '@dndComponents/character/CharacterSheetParent';

export default function CharacterDetails() {
  const { id } = useParams();
  
  if (id) {
    return (
      <CharacterSheetParent
        id={id}
      />
    );
  } else {
    return <>No Character ID</>
  }
}
